import { Injectable } from '@angular/core';
import { EQimaShadowLevel } from '@qima/ngx-qima';

@Injectable({
  providedIn: 'root',
})
export class QimaShadowService {
  public readonly shadowLevel = EQimaShadowLevel;
}
